import styled from "styled-components";

export const Header = styled.h3`
    padding-top: 1.5rem;
`;

export const Container = styled.div`
    background-color: #f3f6f8;
    padding: 2rem;
`;

export const TabHeader = styled.h4`
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-weight: 400;
    font-size: 28px;
`;

export const Paragraph = styled.p`
    margin-top: 1rem;
    font-size: 16px;
    font-weight: 400;
    white-space: pre-wrap;
    word-wrap: break-word;
`;

export const EmptyStateHeader = styled(TabHeader)`
    margin: 6rem 0;
    text-align: center;
`;
